import { apiClient } from '@/api/client'
import type { FeatureFlagsResponse } from './types'

/** GET /portal/admin/api/v2/feature-flags — @permission_required("settings.feature_flags"). */
export async function fetchFeatureFlags(): Promise<FeatureFlagsResponse> {
  const { data } = await apiClient.get<FeatureFlagsResponse>('/portal/admin/api/v2/feature-flags')
  return data
}

/** POST /portal/admin/feature-flags/api/update — same permission as above. */
export async function updateFeatureFlag(key: string, value: boolean): Promise<{ key: string; value: boolean }> {
  const { data } = await apiClient.post<{ key: string; value: boolean }>('/portal/admin/feature-flags/api/update', {
    key,
    value,
  })
  return data
}

export interface ExternalApiLimit {
  key: string
  label: string
  unit: string
  description: string
  value: number | string
  default: number | string
  minimum: number | null
  maximum: number | null
  choices: string[] | null
  updated_by: string | null
  updated_at: string | null
}

/** GET /portal/admin/api/v2/external-api-limits — @permission_required("settings.external_api_limits"). */
export async function fetchExternalApiLimits(): Promise<ExternalApiLimit[]> {
  const { data } = await apiClient.get<{ limits: ExternalApiLimit[] }>('/portal/admin/api/v2/external-api-limits')
  return data.limits
}

/** PATCH, same permission. Validated server-side against each limit's safe range; audited. */
export async function updateExternalApiLimit(key: string, value: number | string): Promise<void> {
  await apiClient.patch('/portal/admin/api/v2/external-api-limits', { key, value })
}
